// TODO: implement hook for web
export const useNotification = (): void => {}
